import BaseEntityDto from '@/models/Shared/BaseEntityDto';
import AppStatus from './AppStatus';

export default class AppDto extends BaseEntityDto {
    name = '';    
    status: AppStatus = AppStatus.Active;
    platform = '';
    storeUrl = '';
    identifier = '';
    minimumVersion = '';
}